import React from 'react';
import Form from 'react-bootstrap/Form';

interface Props {
  id: string;
  label: string;
  groupName: string;
  checked: boolean;
  onCheck: () => void;
}
export function FilterItem({ id, label, groupName, checked, onCheck }: Props) {
  return (
    <Form.Group className="mb-3" controlId={`filter-${groupName}-${id}`}>
      <Form.Check type="checkbox" label={label} checked={checked} onChange={() => onCheck(id)} />
    </Form.Group>
  );
}
